<template>
  <section class="credential-status" :role="error ? 'alert' : 'status'" aria-live="polite" :aria-busy="!error">
    <i v-if="!error" class="el-icon-loading" aria-hidden="true"></i>
    <h2>{{ error ? 'Unable to load this document' : 'Preparing your document' }}</h2>
    <p>{{ error || 'Loading the latest project information…' }}</p>
    <button v-if="error" type="button" @click="$emit('retry')">Try again</button>
  </section>
</template>
<script>
export default { props: { error: { type: String, default: '' } } }
</script>
<style scoped>
.credential-status { margin:40px auto; padding:56px 24px; max-width:720px; text-align:center; color:#26364d; background:#fff; border:1px solid #dce3ed; border-radius:12px; font-family:Arial,sans-serif; }
.credential-status i { font-size:32px; color:#2F509F; }
.credential-status h2 { font-size:20px; margin:20px 0 12px; }
.credential-status p { font-size:15px; color:#53647a; }
.credential-status button { border:0; border-radius:6px; padding:12px 20px; color:white; background:#2F509F; cursor:pointer; }
@media print { .credential-status { display:none; } }
</style>
